// extracted by mini-css-extract-plugin
export var mediaTwoColumns = "style-mod--media-two-columns--9d60f";
export var overlapVideo = "style-mod--overlap-video--6d8bc";
export var twoColumns = "style-mod--two-columns--78e4c";
export var twoColumnsContainerResponsive = "style-mod--two-columns-container-responsive--db522";
export var twoColumnsItems = "style-mod--two-columns-items--a66ad";
export var twoColumnsItemsReverse = "style-mod--two-columns-items-reverse--8cf90";
export var twoColumnsText = "style-mod--two-columns-text--11f4f";
export var twoColumnsTextComplex = "style-mod--two-columns-text-complex--108ac";
export var twoColumnsTextComplexIcon = "style-mod--two-columns-text-complex-icon--cdf00";
export var twoColumnsVideo = "style-mod--two-columns-video--bfb0d";
export var videoContainer = "style-mod--video-container--3e05e";
export var wordBreaksOff = "style-mod--word-breaks-off--7b848";